import { render, staticRenderFns } from "./lessonTag.vue?vue&type=template&id=11676bce"
import script from "./lessonTag.vue?vue&type=script&lang=js"
export * from "./lessonTag.vue?vue&type=script&lang=js"
import style0 from "./lessonTag.vue?vue&type=style&index=0&id=11676bce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports